import { render, staticRenderFns } from "./PatentActivityForm.vue?vue&type=template&id=0fb778eb&scoped=true&"
import script from "./PatentActivityForm.vue?vue&type=script&lang=ts&"
export * from "./PatentActivityForm.vue?vue&type=script&lang=ts&"
import style0 from "./PatentActivityForm.vue?vue&type=style&index=0&id=0fb778eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb778eb",
  null
  
)

export default component.exports